<template>
  <div class="contact-import-process-step">
    <div class="box">
      <h2 class="title is-5">Revisar y finalizar</h2>

      <p class="subtitle is-6">
        Confirma la importación del archivo seleccionado.
      </p>

      <div
        v-if="!submitted && !importError"
        class="notification is-warning is-light"
      >
        Al importar, el backend procesará el archivo seleccionado.
      </div>

      <div
        v-if="submitted && !importError"
        class="notification"
        :class="statusNotificationType"
      >
        <strong>{{ statusTitle }}</strong>
        <br />
        {{ importMessage || "El archivo se está procesando." }}
      </div>

      <div v-if="importError" class="notification is-danger is-light">
        <strong>Error al importar:</strong>
        <br />
        {{ importError }}
      </div>

      <div class="columns mt-4">
        <div class="column">
          <div class="summary-box">
            <p class="heading">Archivo</p>
            <p class="title is-6">
              {{ fileName }}
            </p>
          </div>
        </div>

        <div class="column">
          <div class="summary-box">
            <p class="heading">Filas detectadas</p>
            <p class="title is-4">
              {{ totalRows }}
            </p>
          </div>
        </div>

        <div class="column">
          <div class="summary-box">
            <p class="heading">Estado</p>
            <p class="title is-5">
              {{ statusLabel }}
            </p>
          </div>
        </div>
      </div>

      <b-progress v-if="showProgress" type="is-primary" size="is-small" />

      <div class="buttons mt-4">
        <b-button
          type="is-primary"
          icon-pack="fas"
          icon-left="upload"
          :loading="importing"
          :disabled="importing || submitted || !canImport"
          @click="$emit('start-import')"
        >
          Importar archivo
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactImportProcessStep",

  props: {
    file: {
      type: [File, Object],
      default: null,
    },

    totalRows: {
      type: Number,
      default: 0,
    },

    canImport: {
      type: Boolean,
      default: false,
    },

    importing: {
      type: Boolean,
      default: false,
    },

    submitted: {
      type: Boolean,
      default: false,
    },

    importError: {
      type: String,
      default: "",
    },

    importStatus: {
      type: String,
      default: "",
    },

    importMessage: {
      type: String,
      default: "",
    },
  },

  computed: {
    fileName() {
      return this.file && this.file.name ? this.file.name : "Sin archivo";
    },

    showProgress() {
      return (
        this.importing ||
        this.importStatus === "queued" ||
        this.importStatus === "processing"
      );
    },

    statusLabel() {
      if (this.importing) {
        return "Enviando...";
      }

      if (this.importStatus === "queued") {
        return "En cola";
      }

      if (this.importStatus === "processing") {
        return "Procesando";
      }

      if (this.importStatus === "completed") {
        return "Finalizado";
      }

      if (this.importStatus === "failed" || this.importError) {
        return "Con error";
      }

      if (this.submitted) {
        return "Enviado";
      }

      if (!this.canImport) {
        return "No disponible";
      }

      return "Pendiente";
    },

    statusTitle() {
      if (this.importStatus === "completed") {
        return "Importación procesada correctamente.";
      }

      if (this.importStatus === "processing") {
        return "Importación en proceso.";
      }

      if (this.importStatus === "queued") {
        return "Importación encolada correctamente.";
      }

      if (this.importStatus === "failed") {
        return "La importación falló.";
      }

      return "Importación enviada correctamente.";
    },

    statusNotificationType() {
      if (this.importStatus === "completed") {
        return "is-success is-light";
      }

      if (this.importStatus === "failed") {
        return "is-danger is-light";
      }

      if (this.importStatus === "processing") {
        return "is-info is-light";
      }

      if (this.importStatus === "queued") {
        return "is-warning is-light";
      }

      return "is-info is-light";
    },
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 1rem;
}

.summary-box {
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 6px;
  padding: 1.25rem;
  height: 100%;
}

.summary-box .title {
  word-break: break-word;
}
</style>